import { get } from "http";
import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";


export function useChatAssistantApi() {
  const callApi = useApiCall();

  const postQuery = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.ASSISTANT.SEND, data, onSuccess, onError);
  }

  return {
    postQuery,
  };
}
